import {RouteComponentProps, withRouter} from "react-router";
import * as React from "react";
import User from "../../../model/user/User";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import {Boxed} from "../../../hiberUiKit/src/molecules/Boxed/Boxed";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import Routes from "../../../navigation/route/Route";
import EditUserForm from "../../user/form/edit/EditUserForm";

interface ReduxProps {
	user?: User;
}

interface RouteProps {
	userId: string;
}

type Props = RouteComponentProps<RouteProps> & ReduxProps;

class OrganisationUserUpdate extends React.PureComponent<Props> {
	constructor(props: Props) {
		super(props);
		this.onSuccess = this.onSuccess.bind(this);
		this.onCancel = this.onCancel.bind(this);
	}

	render() {
		if (!this.props.user)
			return null;

		return (
			<Boxed>
				<PageHeaderView header={"Edit User"}/>
				<PageContentView>
					<EditUserForm onSuccess={this.onSuccess} onCancel={this.onCancel} user={this.props.user}/>
				</PageContentView>
			</Boxed>
		);
	}

	/**
	 * On successfully updated User
	 */
	private onSuccess() {
		this.props.history.push(Routes.OrganisationUserList);
	}

	/**
	 * On cancel click.
	 * Redirect to previous page.
	 */
	private onCancel() {
		this.props.history.goBack();
	}
}

function mapStateToProps(state: RootState, props: RouteComponentProps<RouteProps>) {
	return {
		user: state.user.users.getOrElse([]).filter(u => u.id === props.match.params.userId)[0]
	}
}

export default withRouter(connect<ReduxProps>(mapStateToProps)(OrganisationUserUpdate));